<template>
    <div class="el-badge">
        <slot></slot>
        <transition name="el-zoom-in-center">
            <sup v-show="!hidden && (content || isDot)"
                 v-text="content"
                 class="el-badge-content"
                 :class="{ 'is-fixed': $slots.default, 'is-dot': isDot }">
            </sup>
        </transition>
    </div>
</template>

<script>
    export default {
        name:'ElBadge',
        props:{
            value:{},
            max:Number,
            isDot:Boolean,
            hidden:Boolean
        },
        computed:{
            content() {
                if(this.isDot) return;

                const value = this.value;
                const max = this.max;

                if(typeof value === 'number' && typeof max === 'number'){
                    return max < value ? `${max}+` : value;
                }

                return value;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// main.vue?1b0337b0